import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-activation-success',
  template: `
    <div class="success-message">
      <h2>✅ Account Activated Successfully!</h2>
      <p>Your account has been verified. You can now login to your account.</p>
      <a routerLink="/login" class="btn btn-primary">Proceed to Login</a>
    </div>
  `,
  styles: [`
    .success-message {
      text-align: center;
      padding: 50px;
    }
    .btn {
      margin-top: 20px;
    }
  `]
})
export class ActivationSuccessComponent implements OnInit {
  constructor() { }
  ngOnInit() { }
}